import type { Client, RequestContext } from "../client";
import type { PackageResource } from "../resources";
import type { AllArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";
type PackageListArgs = {
    take?: number;
    skip?: number;
    filter?: string;
    nuGetPackageId?: string;
    includeNotes?: boolean;
    latest?: boolean;
};
export interface PackageNoteResult {
    Succeeded: boolean;
    Notes: string | null;
    FailureReason: string | null;
    Published: string | null;
}
export interface PackageNote {
    PackageId: string;
    Version: string;
    FeedId: string;
    Notes: PackageNoteResult;
}
export interface PackageNotesList {
    Packages: PackageNote[];
}
type PackageGetArgs = {
    includeNotes?: boolean;
};
export class PackageRepository extends BasicRepository<PackageResource, PackageResource, PackageListArgs, AllArgs, PackageGetArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Packages", client, requestContext);
    }
    deleteMany(packageIds: string[]) {
        return this.client.del(this.requestContext, this.client.getLink("PackagesBulk"), null, { ids: packageIds });
    }
    upload(pkg: File, replace: boolean) {
        const fd = new FormData();
        fd.append("fileToUpload", pkg);
        return this.client.post<PackageResource>(this.requestContext, this.client.getLink("PackageUpload"), fd, { replace });
    }
    getNotes(packages: PackageNote[]) {
        const packageIds = packages.reduce((result, item) => result + (result.length === 0 ? "" : ",") + encodeURIComponent(item.FeedId) + ":" + encodeURIComponent(item.PackageId) + ":" + encodeURIComponent(item.Version), "");
        return this.client.get<PackageNotesList>(this.requestContext, this.client.getLink("PackageNotesList"), { packageIds });
    }
}
